import React from 'react';

class Option extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    const { option } = props;

    const handleSelect = () => {
      props.onUpdateState(
        { selected: option, inputValue: '', showSelected: true },
        async () => {
          if (props.onChange) {
            await props.onChange(option);
          }

          if (props.closeOnChange) {
            props.onClose();
          }
        }
      );
    };
    return (
      <div key={`selectOptionKey_${option.label}`} class="selectOption">
        {props.link ? (
          <a
            href={option.link}
            onClick={handleSelect}
            class={`optionTrigger ${props.selected.value === option.value ? 'active' : ''}`}
          >
            {props.renderOption ? (
              props.renderOption(option)
            ) : (
              <span>{option.label}</span>
            )}
            {props.selected.value === option.value && (
              <i class="material-icons">done</i>
            )}
          </a>
        ) : (
          <a
            onClick={handleSelect}
            class={`optionTrigger ${props.selected.value === option.value ? 'active' : ''}`}
          >
            {props.renderOption ? (
              props.renderOption(option)
            ) : (
              <span>{option.label}</span>
            )}
            {props.selected.value === option.value && (
              <i class="material-icons">done</i>
            )}
          </a>
        )}
      </div>
    );
  }
}

export default Option;
